import React, { Component } from "react"
import Link from "gatsby-link"

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="weight">
                <h4 className="footer-logo"><img src="/images/logo_white.svg" alt="flogo" style={{width: '170px'}} /></h4>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="weight">
                <h4>{ this.props.lang == 'en' ? 'Contact' : 'Contatti' }</h4>
                <ul>
                  <li><i className="fa fa-phone" aria-hidden="true"></i> Marco Scatto +39 335 1830434</li>
                  <li><i className="fa fa-phone" aria-hidden="true"></i> Enrico Vittadello +39 348 3341964</li>
                  <li><i className="fa fa-envelope-o" aria-hidden="true"></i> info@vedutaconsult.it</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js